import { CarrierAccount } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCarrierAccounts = {
  name: "getCarrierAccounts" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
    // Per-team flag (default OFF) for "Connect GOFO directly" on Redo-child rows.
    gofoDirectEnabled: z.boolean(),
  }),
};
